import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { ImportExcelComponent } from './features/excel/import/import-excel.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'add-visit',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['NV', 'QLCTV'] },
    loadComponent: () => import('./features/examination/exam-form/exam-form.component').then((m) => m.ExamFormComponent)
  },
  {
    path: 'patients/:id/exam/new',
    canActivate: [authGuard],
    loadComponent: () => import('./features/examination/exam-form/exam-form.component').then((m) => m.ExamFormComponent)
  },
  {
    path: 'patients/:id/exam/:examId',
    canActivate: [authGuard],
    loadComponent: () => import('./features/examination/exam-form/exam-form.component').then((m) => m.ExamFormComponent)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },
      {
        path: 'gioithieu',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/gioithieutram/gioithieutram.component').then(
            (m) => m.GioiThieuTramComponent
          )
      },
      {
        path: 'patients',
        loadComponent: () => import('./features/patients/patient-list/patient-list.component').then((m) => m.PatientListComponent)
      },
      {
        path: 'phanboCTV',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['NV', 'QLCTV'] },
        loadComponent: () => import('./features/phanbo/phanbo-ctv.component').then((m) => m.PhanboCtvComponent)
      },
      {
        path: 'khoaPhieuKham',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['NV', 'Admin'] },
        loadComponent: () =>
          import('./features/khoaphieukham/khoaphieukham.component').then(
            (m) => m.KhoaPhieuKhamComponent
          )
      },
      {
        path: 'phanboQLCTV',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['NV', 'Admin'] },
        loadComponent: () =>
          import('./features/qlctv/phanbo-qlctv.component').then(
            (m) => m.PhanboQlctvComponent
          )
      },
      {
        path: 'qlctv/phanbo-khupho',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['NV', 'Admin'] },
        loadComponent: () =>
          import('./features/phanbo-khupho/phanbo-khupho.component').then(
            (m) => m.PhanboKhuPhoComponent
          )
      },
      {
        path: 'excel',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./features/excel/excel-tools.component').then((m) => m.ExcelToolsComponent)
          },
          {
            path: 'export',
            canActivate: [authGuard, roleGuard],
            data: { roles: ['NV', 'QLCTV'] },
            loadComponent: () => import('./features/excel/export/export-excel.component').then((m) => m.ExportExcelComponent)
          },
          {
            path: 'import',
            canActivate: [authGuard, roleGuard],
            data: { roles: ['NV', 'QLCTV'] },
            component: ImportExcelComponent
          }
        ]
      },
      {
        path: 'patients/:id',
        loadComponent: () => import('./features/patients/patient-detail/patient-detail.component').then((m) => m.PatientDetailComponent)
      },
      {
        path: 'reports',
        loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent)
      },
      {
        path: 'settings/nhanvien',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['Admin'] },
        loadComponent: () => import('./features/nhanvien/nhanvien.component').then((m) => m.NhanVienComponent)
      },
      {
        path: 'settings/phan-quyen',
        canActivate: [authGuard, roleGuard],
        data: { roles: ['Admin'] },
        loadComponent: () =>
          import('./features/phanquyen/phanquyen.component').then((m) => m.PhanQuyenComponent)
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings.component').then((m) => m.SettingsComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
